import _ from 'lodash';
import { serializeVisibilityForAmountCaption } from '@/Helpers';

const qualityAnalysisConfig = {
	initialState: {
		fields: {
			amountCaption: [
				{
					caption: 'Total',
					amount: 'N/A',
				},
				{
					caption: 'Passed %',
					amount: 'N/A',
				},
				{
					caption: 'Weight Failure',
					amount: 'N/A',
				},
				{
					caption: 'Temp Failure',
					amount: 'N/A',
				},
				{
					caption: 'Food texture',
					amount: 'N/A',
				},
				{
					caption: 'Cpk',
					amount: 'N/A',
				},
			],
		},
	},
	serializer: (state, data) => {
		return _.update(_.cloneDeep(state), 'fields', () => {
			const newState = {
				amountCaption: [
					...Object.keys(data ?? {}).map((current) => {
						return serializeVisibilityForAmountCaption(data, current);
					}),
				],
			};
			return newState;
		});
	},
};
export default qualityAnalysisConfig;
